<template>
  <div class="login">
    <div class="container">
      <div class="login-logo" v-if="site">
        <img :src="site.pcWebsiteLogo ? site.pcWebsiteLogo : '../assets/pic/login-logo.png'" style="width: 240px; height: 240px" />
      </div>
      <div class="form">
        <el-form :model="form" status-icon ref="form" class="form">
          <div class="login-box">
            <div class="email">
              <el-form-item prop="username" :rules="[{ validator: checkUsername, trigger: 'blur' }]">
                <el-input v-model="form.username" :placeholder="ts('Enter email address')['Enter email address']"></el-input>
              </el-form-item>
            </div>
            <div class="password">
              <el-form-item prop="password" :rules="[{ required: true, message: ts('Password cannot be empty')['Password cannot be empty'] }]">
                <el-input type="password" v-model="form.password" :placeholder="ts('Enter password')['Enter password']" autocomplete="off"></el-input>
              </el-form-item>
            </div>
          </div>
          <div class="tips">{{ ts('By continuing the log-in process, you have read and agreed to our terms of service and cookie policy')['By continuing the log-in process, you have read and agreed to our terms of service and cookie policy'] }}</div>
          <div class="auto-login">
            <el-checkbox v-model="rememberMe">{{ ts('AUTO LOG-IN')['AUTO LOG-IN'] }}</el-checkbox>
          </div>
          <div class="login-submit">
            <el-button :loading="loginBtn" :disabled="loginBtn" class="btn btn-theme" type="primary" @click="submitForm('form')">{{ ts('Enter')['Enter'] }}</el-button>
          </div>
          <router-link :to="{ name: 'forgot-password' }" class="forgot-password">
            <img src="../assets/images/icon-question.svg" width="20" />
            {{ ts('Forgot password?')['Forgot password?'] }}
          </router-link>
          <div class="sign-up">
            {{ ts('Not a member?')['Not a member?'] }} <span @click="$router.push('/register')">{{ ts('Sign up now!')['Sign up now!'] }}</span>
          </div>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import { getAction, postAction } from '@/api/manage'
import { ACCESS_TOKEN, USER_NAME, USER_INFO } from '@/store/mutation-types'
import { LanguagePackage } from '@/mixins/LanguagePackage'
import { mapState } from 'vuex'
import CustomerService from '@/components/CustomerService.vue'

export default {
  name: 'Login',
  mixins: [LanguagePackage],
  data() {
    return {
      form: {
        username: '',
        password: '',
      },
      rememberMe: true,
      requestCodeSuccess: false,
      randCodeImage: '',
      loginBtn: false,
    }
  },
  computed: {
    ...mapState(['site']),
  },
  created() {
    const rememberMe = this.$ls.get('rememberMe')
    if (rememberMe) {
      this.form = { ...rememberMe }
    }
  },
  methods: {
    checkUsername(rule, value, callback) {
      let reg = /^([A-Za-z0-9_\-\.\u4e00-\u9fa5])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,8})$/
      if (!reg.test(value)) {
        callback(new Error(this.translate('請輸入正確的郵箱地址')))
      }

      if (!value) {
        callback(new Error(this.translate('请输入邮箱')))
      } else {
        callback()
      }
    },
    submitForm(formName) {
      this.loginBtn = true
      this.$refs[formName].validate((valid) => {
        if (valid) {
          const data = this.form
          // AUTO LOG-IN
          if (this.rememberMe) {
            this.$ls.set('rememberMe', this.form)
          } else {
            this.$ls.remove('rememberMe')
          }
          postAction(`/pc/home/memberLogin`, data).then((res) => {
            console.log(res)
            this.loginBtn = false
            if (res.code == '200') {
              this.$ls.set(ACCESS_TOKEN, res.result.token, 7 * 24 * 60 * 60 * 1000)
              this.$ls.set(USER_INFO, res.result.userInfo, 7 * 24 * 60 * 60 * 1000)
              this.$store.commit('SET_INFO', res.result.userInfo)
              this.$router.push('/user')
            }
          })
        } else {
          this.loginBtn = false
          return false
        }
      })
    },
    resetForm(formName) {
      this.$refs[formName].resetFields()
    },
  },
}
</script>

<style scoped lang="scss">
.login-logo {
  height: 300px;
}
</style>
